var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"ionicon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('title',[_vm._v("Arrow Back")]),_c('path',{attrs:{"fill":"none","stroke":"#333","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"60","d":"M244 400L100 256l144-144M120 256h292"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }